<div [hidden]="!isLoading" class="page-loader text-center">
    <div class="loader"></div>
</div>

<div class="row">
    <div class="col-sm-12 search-results-content px-0">
        <core-client-search-form [autoFocus]="!hasSearchTerm()"></core-client-search-form>

        <div class="search-top">
            @if ((!hasResults() && hasSearchTerm()) || (hasResults() && introText)) {
                @if (!hasResults() && hasSearchTerm() && search.isActive() && !isLoading) {
                    <p [innerHTML]="noResultsText"></p>
                }
                @if (hasResults() && introText) {
                    <p [innerHTML]="introText"></p>
                }
            }
        </div>

        <div class="search-results__tabs">
            @if ((faq$ | async)?.resource; as faq) {
                <h2>{{ 'Top FAQ' | translate }}</h2>
                <p></p>
                <core-block-ai-faq [faq]="faq"></core-block-ai-faq>
            }

            @if (hasResults()) {
                @if (!isLoading) {
                    <div class="mt-4-5 mb-4">
                        @if (!isListFormat) {
                            <p class="mb-0">
                                Showing <strong [innerText]="getDisplayCount()"></strong> of
                                <strong [innerText]="total"></strong> results
                            </p>
                        } @else {
                            <p class="search-results-list-format__summary mb-0">
                                Showing {{ offset + 1 }}-{{ offset + paginatedResults.length }} of {{ total }} results
                            </p>
                        }
                    </div>
                }
                @if (!isListFormat) {
                    <div
                        (scrolled)="onScroll()"
                        [infiniteScrollDisabled]="searchPagination"
                        [infiniteScrollDistance]="distance"
                        [infiniteScrollThrottle]="throttle"
                        class="g-4 row row-cols-1 row-cols-sm-2 row-cols-md-3"
                        infinite-scroll>
                        @for (card of paginatedResults; track card.id || card.url || idx; let idx = $index) {
                            <div class="col">
                                <core-client-block-card
                                    [cardType]="card.type ?? ''"
                                    [card]="card"
                                    [displayTags]="true"
                                    [parentUrl]="parentUrl(card)"
                                    [zone]="currentZone"></core-client-block-card>
                            </div>
                        }

                        @if (isLoading) {
                            @for (shimmer of getShimmerCards(); track idx; let idx = $index) {
                                <div class="col">
                                    <core-block-card-shimmer></core-block-card-shimmer>
                                </div>
                            }
                        }
                    </div>
                } @else {
                    <div
                        (scrolled)="onScroll()"
                        [infiniteScrollDisabled]="searchPagination"
                        [infiniteScrollDistance]="distance"
                        [infiniteScrollThrottle]="throttle"
                        class="search-results-list-format"
                        infinite-scroll>
                        @for (card of paginatedResults; track card.id || card.url || idx; let idx = $index) {
                            <div class="search-results-list-format__item">
                                @if (!card.isDownload) {
                                    <a
                                        [routerLink]="parentUrl(card) + '/' + card.url"
                                        class="search-results-list-format__link">
                                        <div class="search-results-list-format__header">
                                            <h3
                                                class="search-results-list-format__title"
                                                [innerHTML]="card.name"
                                                [ngStyle]="{
                                                    '--search-results-title-text-color': resultTitleColor,
                                                }"></h3>
                                            @if (showResultIcon) {
                                                <span class="material-symbols-outlined search-results-list-format__icon"
                                                    >arrow_forward</span
                                                >
                                            }
                                        </div>

                                        @if (showResultUrl) {
                                            <p class="search-results-list-format__results-url">
                                                {{ getFullResultLink(card) }}
                                            </p>
                                        }

                                        @if (card.description) {
                                            <p
                                                class="search-results-list-format__description"
                                                [innerHTML]="card.description | limitTo: 250"></p>
                                        }
                                    </a>
                                } @else {
                                    <a
                                        (click)="downloadItem(card.token)"
                                        class="search-results-list-format__link"
                                        href="javascript:void(0)">
                                        <div class="search-results-list-format__header">
                                            <h3 class="search-results-list-format__title" [innerHTML]="card.name"></h3>
                                            <span class="material-symbols-outlined search-results-list-format__icon"
                                                >download</span
                                            >
                                        </div>

                                        @if (showResultUrl) {
                                            <p class="search-results-list-format__results-url">
                                                {{ getFullResultLink(card) }}
                                            </p>
                                        }

                                        @if (card.description) {
                                            <p
                                                class="search-results-list-format__description"
                                                [innerHTML]="card.description | limitTo: 250"></p>
                                        }
                                    </a>
                                }
                            </div>
                        }

                        @if (isLoading) {
                            @for (shimmer of getShimmerCards(); track idx; let idx = $index) {
                                <div class="search-results-list-format__shimmer">
                                    <div class="shimmer-title"></div>
                                    <div class="shimmer-description"></div>
                                </div>
                            }
                        }
                    </div>
                }

                @if (searchPagination) {
                    @if (paginationItems.length > 1) {
                        <nav aria-label="Card pagination" class="pagination-wrapper mt-5">
                            <ul class="pagination justify-content-center flex-wrap gap-2">
                                <li class="page-item" [ngClass]="{ disabled: !hasPreviousPage || isLoading }">
                                    <a
                                        (click)="!isLoading && previousPage()"
                                        class="page-link"
                                        href="javascript:void(0)"
                                        >Previous</a
                                    >
                                </li>
                                @for (item of paginationItems; track idx; let idx = $index) {
                                    <li
                                        [ngClass]="{
                                            active: item.active,
                                            disabled: item.isEllipsis || isLoading,
                                            'is-ellipsis': item.isEllipsis,
                                        }"
                                        class="page-item">
                                        @if (item.isEllipsis) {
                                            <span class="page-link">{{ item.label }}</span>
                                        } @else {
                                            <a
                                                (click)="!isLoading && navigateOffset(item.offset)"
                                                class="page-link"
                                                href="javascript:void(0)"
                                                >{{ item.label }}</a
                                            >
                                        }
                                    </li>
                                }
                                <li class="page-item" [ngClass]="{ disabled: !hasNextPage || isLoading }">
                                    <a (click)="!isLoading && nextPage()" class="page-link" href="javascript:void(0)"
                                        >Next</a
                                    >
                                </li>
                            </ul>
                        </nav>
                    }
                } @else {
                    @if (hasMoreContent()) {
                        <button
                            (click)="loadMore()"
                            [innerText]="loadMoreText"
                            class="btn btn-secondary d-block mx-auto mt-3"></button>
                    }
                }
            }
        </div>
    </div>
</div>
